"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeToSupportedLanguage = exports.SupportedLanguage = void 0;
const PublicConfig_1 = require("../Config/PublicConfig");
/**
 * full list visit https://developers.google.com/admin-sdk/directory/v1/languages
 */
var SupportedLanguage;
(function (SupportedLanguage) {
    SupportedLanguage["EN"] = "en";
    SupportedLanguage["FR"] = "fr";
    //ZH_CN = "zh-CN",
    //DE = "de",
    //ES = "es",
})(SupportedLanguage = exports.SupportedLanguage || (exports.SupportedLanguage = {}));
function localeToSupportedLanguage(locale) {
    var _a;
    const candidates = locale
        ? [locale.toLowerCase(), locale.toLowerCase().substring(0, 2)]
        : [(0, PublicConfig_1.publicConfig)().i18n.fallbackLng];
    return ((_a = candidates.find((candidate) => Object.values(SupportedLanguage).includes(candidate))) !== null && _a !== void 0 ? _a : (0, PublicConfig_1.publicConfig)().i18n.fallbackLng);
}
exports.localeToSupportedLanguage = localeToSupportedLanguage;
//# sourceMappingURL=Language.js.map